"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAll = exports.reset = exports.show = void 0;
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var show = function (doShow) {
    voyageLayers_sidecar_1.voyageLayers.getLayers().starfield1.visible = doShow;
};
exports.show = show;
var reset = function () {
    if (objs.length === 0) {
        for (var i = 0; i < 700; i++) {
            createStar();
        }
    }
    for (var i = 0; i < objs.length; i++) {
        var c = objs[i];
        randomizeStar(c);
    }
    voyageLayers_sidecar_1.voyageLayers.getLayers().starfield1.sort('depth');
    updateAll();
};
exports.reset = reset;
var colors = [voyageColors_sidecar_1.voyageColors.yellow, 0xffffff];
var randomizeStar = function (obj) {
    var cb = voyageCamera_sidecar_1.voyageCamera.get().bounds;
    var x = rando_sidecar_1.rando.f(cb.x, cb.x + cb.w);
    var y = rando_sidecar_1.rando.f(cb.y, cb.y + cb.h);
    obj.x = x;
    obj.y = y;
    obj.image.x = x;
    obj.image.y = y;
    // obj.image.angle = rando.f(0, 360)
    obj.depth = rando_sidecar_1.rando.f(0.1, 1);
    spritesUtil_sidecar_1.spritesUtil.scale(obj.image, Math.floor(obj.depth * 2));
    // obj.image.scale =
    obj.image.depth = obj.depth;
    obj.image.tint = rando_sidecar_1.rando.sample(colors);
    obj.image.alpha = rando_sidecar_1.rando.f(0.5, 1);
};
// let frame = frameInfo.fi32(8, 21, 9)
var createStar = function () {
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rando_sidecar_1.rando.sample([voyageLayers_sidecar_1.voyageLayers.getLayers().starfield1]), rando_sidecar_1.rando.sample([
        sprites_sidecar_1.sprites.voyTileParticlesStar2[0],
        sprites_sidecar_1.sprites.voyTileParticlesStar3[0],
        sprites_sidecar_1.sprites.voyTileParticlesStar[0],
        sprites_sidecar_1.sprites.voyTileParticlesRound[1],
    ]));
    var obj = {
        image: image,
        x: 0,
        y: 0,
        depth: 1,
    };
    objs.push(obj);
    return obj;
};
var objs = [];
function updateAll() {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var scale = 1;
    var depthScale = 0.05;
    var cb = voyageCamera_sidecar_1.voyageCamera.get().bounds;
    //let gb = voyageCamera.getGameBounds()
    // let playWidth = (ctx.mapShip.width - 1) * ctx.mapShip.tileSize
    // let playHeight = (ctx.mapShip.height - 1) * ctx.mapShip.tileSize
    //let centerXY = { x: gb.width / 2, h: gb.height / 2 }
    // let sx = stevieCam.get().cameraX // - playWidth / 2
    // let sy = stevieCam.get().cameraY // - playHeight / 2
    // let cx = playWidth / 2
    // let cy = playHeight / 2
    for (var i = 0; i < objs.length; i++) {
        var c = objs[i];
        c.x -= ds * c.depth * 20;
        //c.x += ds * c.depth * 20
        if (c.x < cb.x) {
            c.x += cb.w;
        }
        if (c.x > cb.x + cb.w) {
            c.x -= cb.w;
        }
        c.image.x = c.x; //  + -(cx - centerXY.x) * (1 - c.depth * depthScale) * scale
        c.image.y = c.y; // + -(cy - centerXY.y) * (1 - c.depth * depthScale) * scale
    }
    // let sx = stevieCam.get().cameraX
    // let sy = stevieCam.get().cameraY
    // let d = common.getUpdateDeltaScaled()
    // let scale = 0.25
    // let ctx = scene.getContext()
    // let playWidth = (ctx.mapShip.width - 1) * ctx.mapShip.tileSize
    // for (let i = 0; i < objs.length; i++) {
    //   let c = objs[i]
    //   c.x -= d * c.depth * 10
    //   if (c.x < 0) {
    //     c.x += playWidth
    //   }
    //   c.image.x = c.x + sx * (1 - c.depth) * scale
    //   c.image.y = c.y + sy * (1 - c.depth) * scale
    //   // c.image.y = c.y +
    // }
    // objs.forEach((c) => {
    //   update(c)
    // })
}
exports.updateAll = updateAll;
// function update(obj: IParticle) {
//   let d = common.getUpdateDeltaScaled()
//   let dx = (obj.dir.x * obj.speed * d) / 100
//   let dy = (obj.dir.y * obj.speed * d) / 100
//   obj.angle += (obj.angleSpeed * (2 * Math.PI)) / 60
//   obj.image.rotation = obj.angle
//   obj.image.x += dx
//   obj.image.y += dy
//   obj.timeLeft -= d
//   if (obj.timeLeft < 0) {
//     kill(obj)
//   }
// }
